export default __webpack_public_path__ + "static/media/receive-shoot-request.65bfdf41.png";